// 站点管理
import http from "@/jslibs/axios/http";

// 新增站点
export const add = (data) => http.post("/cms/site/add", data);

// 编辑站点
export const edit = (data) => http.post("/cms/site/update", data);
// 站点详情
export const detail = (id) => http.get("/cms/site/details/" + id);
// 站点删除
export const del = (id) => http.delete("/cms/site/" + id);
// 站点分页列表
export const page = (data) => http.get("/cms/site/page", data);
// 站点分页列表
export const list = (data) => http.get("/cms/site/list", data);